import { Component, Injector, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';

@Component({
  selector: 'app-product-field-time',
  templateUrl: './product-field-time.component.html',
  styleUrls: ['./product-field-time.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldTimeComponent),
      multi: true,
    },
  ],
})
export class ProductFieldTimeComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor
{
  value: any | null = null;
  constructor(injector: Injector) {
    super(injector);
  }
  onChange: any = (value: any) => {};
  onTouched: any = () => {};
  writeValue(value: any): void {
    this.value = value;
    this.onChange(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
